import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { GET_ALL_USER_ROLES } from "../constants/constants";
import { fetchGetAllUserRolesSuccess, fetchGetAllUserRolesFailure } from "./reducer"

export const fetchAllUserRoles = (setLoading, domain) => async (dispatch) => {
    try {
        setLoading(true)
        const API_URL = `${GET_ALL_USER_ROLES}` + `?domain=${domain}`
        const response = await determineBaseUrlAndPerformApiCall(API_URL, 'GET')
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchGetAllUserRolesSuccess([]));
        }
        else {
            dispatch(fetchGetAllUserRolesSuccess(response))
        }
    }
    catch (error) {
        dispatch(fetchGetAllUserRolesFailure(error.message))
    }
    finally {
        setLoading(false);
    }
}